import React from 'react'
import { UserConfig } from 'types'

import { State, ActionType } from '../constants'

export const reducer: React.Reducer<
  State,
  | { type: ActionType.SetPartnerData; payload: UserConfig }
  | {
      type: ActionType.SetMasqueradePartnerId
      payload: string
    }
> = (state, action) => {
  switch (action.type) {
    case ActionType.SetPartnerData:
      return {
        ...state,
        canDownloadPartnerDataSharingReports:
          action.payload.accountAccess?.canDownloadPartnerDataSharingReports,
        partner: action.payload.activePartner,
        availablePartners: action.payload.partners || [],
      }

    case ActionType.SetMasqueradePartnerId:
      return {
        ...state,
        masqueradePartnerId: action.payload,
      }
    default:
      return state
  }
}

export const setPartnerData =
  (
    dispatch: React.Dispatch<{
      type: ActionType.SetPartnerData
      payload: UserConfig
    }>
  ) =>
  (payload: UserConfig): void =>
    dispatch({
      type: ActionType.SetPartnerData,
      payload,
    })

export const setMasqueradePartnerId =
  (
    dispatch: React.Dispatch<{
      type: ActionType.SetMasqueradePartnerId
      payload: string
    }>
  ) =>
  (payload: string): void =>
    dispatch({
      type: ActionType.SetMasqueradePartnerId,
      payload,
    })
